import Box, { type BoxProps } from "@mui/material/Box";

export function CarSVG({
  lineStroke = "black",
  ...boxProps
}: { lineStroke: string } & BoxProps) {
  return (
    <Box {...boxProps}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 450 727"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
      >
        <title>Car Illustration</title>
        <rect
          x="3"
          y="3"
          width="440"
          height="714"
          rx="80"
          stroke={lineStroke}
          strokeWidth="6"
        />
        <line
          x1="0.999756"
          y1="227.25"
          x2="441.001"
          y2="227.25"
          stroke={lineStroke}
          strokeWidth="6"
        />
        <line
          x1="0.999512"
          y1="494.5"
          x2="446.001"
          y2="494.5"
          stroke={lineStroke}
          strokeWidth="6"
        />
        <line
          x1="222.156"
          y1="195.069"
          x2="110.648"
          y2="1.93134"
          stroke={lineStroke}
          strokeWidth="6"
        />
        <line
          x1="221.326"
          y1="191.597"
          x2="330.228"
          y2="2.97222"
          stroke={lineStroke}
          strokeWidth="6"
        />
        <line
          x1="225.598"
          y1="505.5"
          x2="347.912"
          y2="717.355"
          stroke={lineStroke}
          strokeWidth="6"
        />
        <path
          d="M97.7123 718.001L217.875 499"
          stroke={lineStroke}
          strokeWidth="6"
        />
        <path
          d="M323.485 545.1C323.485 593.5 283.085 632.8 233.185 632.8H204.585C154.685 632.8 114.285 593.5 114.285 545.1V169.6C114.285 121.2 154.685 85.3 204.585 85.3H233.185C283.085 85.3 323.485 121.2 323.485 169.6V545.1Z"
          fill="#353635"
          stroke="#231F20"
          strokeWidth="9"
          strokeMiterlimit="10"
        />
        <path
          d="M358.585 256.8C353.685 251.8 342.285 248.9 338.185 248C337.985 239.3 336.585 229.8 336.085 218.8C336.585 225.5 336.985 229.8 336.985 229.8C336.985 229.8 340.385 203 339.285 189.4C338.285 177.4 336.385 168.9 334.885 163.7C333.485 151 330.985 137.6 326.685 126.6C325.685 121.5 322.185 115.1 316.985 109.2C311.285 102.8 302.385 97.4 294.685 94.6C292.985 93.8 291.385 93.1 289.685 92.4C273.885 85.8 260.185 84.6 260.085 84.6H187.085C186.885 84.6 170.785 86.1 153.385 94.2H153.185C145.185 96.9 135.785 102.5 129.885 109.2C124.385 115.5 120.685 122.4 120.085 127.6C115.885 138.7 113.385 152.2 112.085 164.9C110.585 170.1 108.885 178.3 107.985 189.4C106.985 202 109.785 226.2 110.185 229.4C109.585 236.1 108.885 242.2 108.785 248C104.485 248.9 93.285 251.8 88.485 256.8C83.385 262.1 83.785 270.7 84.285 274.6C84.385 275.5 85.085 276 85.785 276C86.485 276 86.285 276 86.585 275.8L101.285 269.4C101.285 269.4 101.385 269.4 101.485 269.3C101.485 269.3 101.585 269.3 101.685 269.2C101.985 269 102.285 268.6 102.485 268.3C102.685 268 102.785 267.6 102.885 267.2V266.5C102.885 264.7 102.985 262 104.585 259.5C105.685 257.7 107.385 256.6 108.785 255.9V268.7H108.885C108.885 268.7 108.485 317.5 108.485 334C108.485 350.5 107.785 352.3 107.085 363.1C106.885 366.2 106.685 368.9 106.585 371C106.285 377.5 105.985 384.6 105.985 392.6C105.785 418.6 105.785 424 107.085 448.2C107.085 449.8 107.285 451.3 107.385 452.8C107.985 463 108.385 470.2 108.885 475.8C109.485 484.2 109.985 489 110.385 494.8C111.085 504.9 108.685 511.9 108.285 522.5C107.785 536.1 109.485 549.4 112.385 560.8C114.785 570.5 117.885 574.4 119.985 581.5C120.485 583.3 120.885 584.8 121.285 586.1V586.3C121.585 587.6 121.885 588.8 122.185 590V590.3C122.185 590.6 122.385 590.9 122.485 591.2C122.585 591.7 122.685 592 122.885 592.4V592.7C122.985 593 123.085 593.3 123.285 593.6C123.485 593.9 123.585 594.3 123.785 594.6V594.9C123.985 595.3 124.185 595.6 124.385 596C124.385 596.2 124.585 596.4 124.685 596.6H124.785C124.785 596.8 124.985 597 125.085 597.1C125.085 597.1 125.085 597.1 125.185 597.3C125.285 597.5 125.385 597.7 125.485 597.9C125.485 597.9 125.585 598.1 125.685 598.2C125.685 598.2 125.685 598.2 125.785 598.4C125.985 598.6 126.085 598.8 126.285 599C126.285 599 126.385 599 126.485 599.2C126.485 599.2 126.585 599.4 126.685 599.5C126.785 599.7 126.985 599.8 127.085 600C127.085 600 127.285 600.2 127.385 600.3C127.385 600.3 127.485 600.3 127.585 600.5C127.785 600.7 127.885 600.9 128.085 601.1L128.385 601.4C128.385 601.4 128.585 601.6 128.585 601.7H128.685C128.985 602.2 129.385 602.5 129.685 602.9L129.885 603.1C130.085 603.3 130.285 603.5 130.485 603.7C130.485 603.7 130.585 603.7 130.685 603.9C130.785 603.9 130.985 604.2 131.185 604.3C131.385 604.5 131.585 604.7 131.885 604.9C131.885 604.9 131.985 604.9 132.085 605.1C132.285 605.3 132.485 605.5 132.685 605.7C133.185 606.1 133.685 606.6 134.185 607.1C134.185 607.1 134.285 607.1 134.385 607.3C135.085 607.9 135.885 608.6 136.785 609.3C136.785 609.3 136.885 609.3 136.985 609.3C137.385 609.6 137.685 609.9 138.085 610.2C138.285 610.2 138.485 610.5 138.685 610.6C139.085 610.9 139.585 611.3 139.985 611.6H140.185C140.985 612.3 141.885 612.9 142.785 613.6C143.385 614 143.885 614.4 144.485 614.8C144.485 614.8 144.585 614.8 144.685 614.8H144.885C145.485 615.2 146.185 615.6 146.885 616H146.985C153.585 620 161.585 623.8 171.085 626.6C197.985 634.7 222.585 635.1 222.585 635.1H222.785C222.785 635.1 247.385 634.7 274.285 626.6C283.785 623.7 291.785 620 298.385 616C298.385 616 298.485 616 298.585 616C299.285 615.5 300.085 615.1 300.785 614.6H300.985C302.585 613.6 304.085 612.5 305.485 611.5H305.585C306.685 610.7 307.785 609.8 308.785 609C309.685 608.3 310.485 607.6 311.285 606.9C312.085 606.2 312.885 605.5 313.585 604.8H313.685C314.085 604.3 314.485 603.9 314.885 603.5H314.985C315.185 603.2 315.485 602.9 315.685 602.7C316.185 602.2 316.685 601.6 317.185 601.1C317.185 601.1 317.385 600.9 317.385 600.8C317.585 600.6 317.785 600.4 317.985 600.2C317.985 600.2 318.185 600 318.285 599.9C318.485 599.7 318.585 599.5 318.785 599.3H318.885C318.885 599.3 318.985 599 319.085 599C319.285 598.7 319.585 598.4 319.785 598.2C319.785 598.2 319.885 598 319.985 597.9C320.085 597.7 320.185 597.6 320.385 597.4C320.385 597.4 320.485 597.2 320.585 597.2C320.685 597.2 320.785 596.9 320.885 596.8C320.985 596.5 321.085 596.3 321.185 596.1L321.785 594.9V594.7C321.985 594.3 322.185 594 322.285 593.6C322.385 593.2 322.485 592.9 322.685 592.6V592.2C322.785 591.9 322.885 591.6 322.985 591.3C322.985 591.3 322.985 591.1 323.085 590.9C323.085 590.7 323.185 590.5 323.285 590.2V589.4C323.285 589.2 323.385 589 323.485 588.7C323.685 587.7 323.985 586.7 324.285 585.5C324.585 584.2 324.985 582.8 325.485 581.2C325.885 579.9 326.285 578.7 326.685 577.6C326.985 576.9 327.385 576 327.685 575.1C329.385 571 331.385 567.1 332.985 560.5C335.785 549 337.585 535.8 337.085 522.2C336.685 511.6 334.285 504.5 334.985 494.5C335.385 488.8 335.885 484 336.485 475.5C336.885 469.9 337.385 462.6 337.985 452.5C337.985 451 338.185 449.5 338.285 447.9C339.585 423.7 339.485 418.2 339.385 392.3C339.385 384.3 339.085 377.1 338.785 370.7C338.585 366.5 338.185 360.2 337.685 353.1C337.285 346.3 336.885 340 336.885 333.7C336.885 317.3 336.485 268.4 336.485 268.4V255.5C337.985 256.2 339.685 257.3 340.785 259.2C342.285 261.7 342.485 264.4 342.485 266.2V266.9C342.485 267.4 342.785 267.8 342.985 268.2C343.085 268.4 343.285 268.5 343.385 268.7C343.585 268.8 343.685 269 343.885 269L358.585 275.4C358.685 275.4 358.885 275.4 358.985 275.5H359.685C359.785 275.5 359.885 275.5 359.985 275.4C360.485 275.2 360.785 274.7 360.885 274.1C361.385 270.2 361.685 261.6 356.685 256.3L358.585 256.7V256.8Z"
          fill="#040404"
        />
        <path
          d="M362.885 259.7C365.185 265.4 364.785 271.7 364.385 274.7C364.385 274.7 364.385 274.7 364.385 274.8C364.085 276.5 363.185 277.9 361.785 278.6C361.285 278.9 360.585 279.2 359.585 279.2H358.885C358.485 279.2 358.185 279.2 357.785 279C357.485 279 357.285 278.9 357.085 278.8L342.685 272.5C342.185 272.3 341.685 272.1 341.285 271.7C340.985 271.5 340.685 271.2 340.385 270.9C340.285 270.8 340.085 270.6 339.985 270.4C339.985 279.7 340.385 319.4 340.385 333.7C340.385 348 340.685 345.3 341.085 351.5V352.9C341.685 360.4 342.085 366.5 342.285 370.5C342.585 376.7 342.885 384.1 342.885 392.3V396.2C342.985 418.9 342.985 425 341.785 448C341.785 448.6 341.785 449.2 341.685 449.8C341.685 450.7 341.485 451.6 341.485 452.4C341.485 453.2 341.485 452.5 341.485 452.6C340.885 463.2 340.385 470.5 339.985 475.6C339.685 480.3 339.385 483.9 339.085 487C338.885 489.6 338.685 492 338.485 494.6C338.085 500.1 338.685 504.8 339.385 509.7C339.885 513.4 340.385 517.3 340.585 521.9C341.085 534.6 339.685 547.8 336.385 561.2C334.985 566.8 333.385 570.6 331.885 574C331.585 574.8 331.185 575.5 330.885 576.3C330.585 577.2 330.185 578 329.985 578.7V578.9C329.585 579.9 329.185 581 328.785 582.2C328.285 583.9 327.885 585.1 327.685 586.3C327.585 586.8 327.485 587.2 327.385 587.6C327.185 588.2 327.085 588.8 326.985 589.4C326.985 589.5 326.985 589.7 326.885 589.8V590.1C326.885 590.5 326.885 590.9 326.685 591.2V591.4C326.585 591.5 326.585 591.7 326.485 591.8C326.485 592 326.485 592.1 326.385 592.3V592.7C326.185 593.3 326.085 593.8 325.785 594.3C325.685 594.9 325.385 595.4 325.285 595.7C325.285 595.9 325.185 596.1 325.085 596.3L324.285 597.8C324.185 598.2 323.985 598.5 323.785 598.8C323.685 599 323.485 599.2 323.185 599.5C323.185 599.5 323.185 599.5 323.085 599.6C323.085 599.6 323.085 599.7 322.985 599.8C322.785 600.1 322.685 600.3 322.485 600.5C322.485 600.5 322.285 600.7 322.185 600.8C321.985 601.1 321.785 601.3 321.585 601.5C321.385 601.8 321.185 602 320.985 602.2C320.985 602.2 320.985 602.2 320.885 602.3C320.885 602.3 320.785 602.4 320.685 602.5L320.385 602.8C320.285 603 320.085 603.2 319.885 603.4C319.685 603.6 319.485 603.8 319.285 604.1C318.985 604.4 318.685 604.7 318.385 605L316.785 606.6C316.085 607.3 314.785 608.5 313.985 609.2C313.185 609.9 312.185 610.8 311.185 611.6L310.685 612C309.785 612.7 308.885 613.5 307.885 614.2C307.685 614.3 307.485 614.4 307.285 614.5H307.185C306.085 615.4 304.785 616.3 303.485 617.1C303.185 617.3 302.885 617.5 302.585 617.7C302.285 617.9 302.085 618 301.785 618.2C301.485 618.4 301.285 618.5 300.985 618.7C300.685 618.9 300.485 619.1 300.185 619.2C292.885 623.6 284.585 627.2 275.585 630C248.485 638.2 224.085 638.6 223.085 638.7H222.785C221.685 638.7 197.285 638.2 170.285 630C161.685 627.5 153.385 623.9 145.785 619.3C145.585 619.3 145.485 619.2 145.285 619.1C144.785 618.8 144.285 618.5 143.685 618.2C143.485 618.2 143.285 618 143.085 618C142.885 618 142.785 617.8 142.585 617.7C142.285 617.5 141.885 617.2 141.585 617C141.385 616.8 141.085 616.7 140.885 616.5C140.885 616.5 140.785 616.5 140.685 616.3C140.185 615.9 139.685 615.6 139.285 615.2C138.985 615 138.685 614.8 138.385 614.6C138.185 614.6 138.085 614.4 137.885 614.3C137.685 614.1 137.385 613.9 137.185 613.7C137.085 613.6 136.885 613.5 136.785 613.4C136.585 613.3 136.485 613.2 136.385 613.1C136.285 613.1 136.185 613 136.085 612.9C135.785 612.7 135.585 612.5 135.385 612.3C135.385 612.3 135.285 612.3 135.185 612.2C134.985 612.2 134.885 612 134.685 611.9C133.885 611.2 133.085 610.6 132.485 610.1L132.185 609.8C132.185 609.8 132.085 609.7 131.985 609.6L131.785 609.4C131.385 609 130.885 608.5 130.585 608.3C130.485 608.3 130.385 608.1 130.285 608L129.685 607.4C129.485 607.2 129.185 607 129.085 606.9C128.785 606.7 128.485 606.4 128.285 606.2L127.285 605.2C127.185 605.1 127.085 605 126.985 604.8C126.985 604.8 126.885 604.7 126.785 604.6C126.585 604.4 126.385 604.2 126.085 603.9C125.985 603.7 125.785 603.6 125.685 603.4C125.485 603.1 125.285 602.9 125.085 602.7C124.685 602.4 124.485 602.1 124.285 601.8C124.185 601.7 124.085 601.5 123.885 601.3C123.885 601.3 123.885 601.2 123.785 601.1C123.585 600.9 123.485 600.7 123.285 600.5C122.985 600.2 122.785 599.9 122.685 599.6C122.585 599.4 122.485 599.3 122.385 599.2C122.285 599 122.185 598.8 122.085 598.7C122.085 598.7 121.985 598.6 121.885 598.5C121.885 598.4 121.685 598.3 121.685 598.1C121.585 597.9 121.285 597.5 121.185 597.1C121.185 597.1 121.185 597.1 121.185 597C121.085 596.8 120.885 596.5 120.785 596.3C120.685 596.1 120.485 595.7 120.485 595.4C120.085 594.7 119.885 594.1 119.785 593.7C119.785 593.5 119.685 593.3 119.685 593.1C119.585 592.8 119.485 592.4 119.385 592C119.185 591.6 118.985 591 118.985 590.3C118.685 589.2 118.485 588.1 118.185 587C118.185 586.9 118.185 586.7 118.185 586.6C117.885 585.7 117.685 584.7 117.385 583.6L117.085 582.4C116.285 579.7 115.285 577.3 114.185 574.9C112.685 571.4 110.885 567.5 109.485 561.6C106.285 548.9 104.785 535.3 105.285 522.3C105.485 517.7 105.985 513.9 106.485 510.2C107.185 505.2 107.785 500.6 107.385 495C107.185 492.3 106.985 489.7 106.785 487C106.485 483.9 106.285 480.5 105.885 476.1C105.485 471.1 105.085 464.9 104.585 456.4L104.385 453.1C104.385 452.7 104.385 452.2 104.285 451.7C104.285 450.6 104.085 449.5 104.085 448.3C102.785 424.2 102.785 418.5 102.985 392.6C102.985 384.6 103.285 377.5 103.585 370.9C103.585 369.4 103.785 367.7 103.885 365.7L104.085 363C104.285 359.9 104.485 357.5 104.685 355.4C105.185 350 105.485 345.8 105.485 334.1C105.485 322.4 105.785 279.9 105.885 270.7C105.485 271.3 104.985 271.8 104.485 272.1C104.285 272.3 103.985 272.5 103.685 272.6C103.485 272.7 103.285 272.8 103.085 272.9L88.7849 279.1C87.6849 279.7 86.6849 279.7 86.3849 279.7C83.7849 279.7 81.5849 277.7 81.2849 275.1C80.6849 270.1 80.4849 260.7 86.4849 254.4C91.1849 249.5 100.585 246.5 105.885 245.2C106.085 241.4 106.385 237.5 106.785 233.4C106.885 232.1 106.985 230.9 107.185 229.6C106.785 226.3 103.985 202.3 104.985 189.3C105.985 177.4 107.785 169.2 109.085 164.4C110.185 154.2 112.385 139.6 117.085 126.9C117.885 121 121.785 113.8 127.685 107C133.485 100.4 142.785 94.4 151.985 91.1C152.185 91 152.485 90.9 152.685 90.8C170.985 82.4 187.385 81 187.585 81H260.585C260.685 81 274.885 82.1 291.585 89.1C293.385 89.8 294.985 90.5 296.585 91.3C305.585 94.6 314.585 100.5 320.185 106.8C325.685 113 329.485 119.8 330.685 125.6C334.485 135.5 337.285 148.1 338.985 163C340.485 168.2 342.385 176.9 343.385 189.1C344.485 202.9 341.185 229.1 341.085 230.3C341.085 230.3 341.085 230.4 341.085 230.5C341.085 231.5 341.285 232.4 341.385 233.3C341.785 237.4 342.085 241.3 342.285 245.1C345.785 246 350.485 247.4 354.785 249.5C359.085 251.6 362.085 255.2 363.485 259.6L362.885 259.7ZM148.185 612.9C148.385 612.9 148.585 613.1 148.785 613.2C155.985 617.6 163.785 621 172.085 623.4C198.185 631.3 222.385 631.7 222.585 631.8H222.685C222.885 631.8 247.085 631.3 273.185 623.5C281.685 620.9 289.585 617.4 296.485 613.3C296.485 613.3 296.685 613.3 296.685 613.2C297.085 613 297.385 612.7 297.785 612.5C298.085 612.3 298.385 612.2 298.685 612C298.885 611.9 298.985 611.8 299.185 611.7C300.385 610.9 301.585 610.1 302.785 609.2L303.385 608.8C303.585 608.7 303.685 608.6 303.885 608.5C304.585 608 305.285 607.4 305.985 606.8L306.485 606.4C307.385 605.7 308.085 605.1 308.885 604.4C309.685 603.7 310.385 603.1 310.985 602.5L313.085 600.4C313.285 600.2 313.485 600 313.685 599.7C313.885 599.5 314.085 599.3 314.285 599C314.385 598.8 314.585 598.6 314.785 598.4L315.185 598C315.385 597.8 315.485 597.6 315.685 597.4C315.785 597.2 315.885 597.1 316.085 597C316.185 596.8 316.385 596.7 316.485 596.5C316.585 596.3 316.785 596.2 316.885 596C317.085 595.7 317.285 595.4 317.485 595.2C317.485 595.2 317.585 595.1 317.685 595L318.285 593.9C318.285 593.7 318.385 593.4 318.485 593.2C318.485 593.1 318.585 592.9 318.685 592.8C318.685 592.7 318.685 592.6 318.685 592.5C318.685 592.3 318.785 592.1 318.985 591.8C318.985 591.6 318.985 591.4 319.085 591.2L319.285 590.7C319.285 590.5 319.285 590.3 319.385 590.1C319.385 590 319.385 589.9 319.385 589.7V589.5C319.385 588.7 319.585 588.2 319.685 587.8C319.785 587.1 319.985 586.5 320.185 585.8C320.185 585.4 320.385 585.1 320.485 584.7C320.785 583.5 321.185 582 321.785 580.2C322.185 578.9 322.585 577.6 323.085 576.4C323.085 576.4 323.085 576.3 323.085 576.2V575.9C323.485 575.3 323.785 574.6 323.985 574V573.8C324.285 573 324.685 572.2 325.085 571.3C326.485 568.1 327.985 564.7 329.185 559.7C332.285 547 333.585 534.4 333.185 522.4C332.985 518.2 332.485 514.5 332.085 510.9C331.385 505.6 330.685 500.5 331.085 494.3C331.285 491.7 331.485 489.3 331.685 486.6C331.985 483.5 332.285 479.9 332.585 475.3C332.985 470.2 333.485 462.9 334.085 452.4C334.085 451.3 334.085 450.3 334.285 449.3C334.285 448.8 334.285 448.3 334.385 447.7C335.585 424.9 335.585 418.9 335.485 396.3V392.3C335.485 384.2 335.185 377 334.885 370.9C334.685 367 334.285 360.9 333.785 353.4V352C333.285 345.7 332.985 339.7 332.985 333.7C332.985 317.5 332.585 268.9 332.585 268.4V255.5C332.585 254.3 333.185 253.1 334.285 252.5C335.285 251.8 336.585 251.8 337.785 252.3C340.385 253.5 342.385 255.3 343.685 257.5C345.085 259.9 345.885 262.7 345.885 266.1L357.285 271.1C357.385 267.6 356.985 262.2 353.785 258.9C353.285 258.4 352.985 257.8 352.885 257.2C348.785 254.7 342.385 252.7 337.085 251.6C335.485 251.2 334.285 249.8 334.285 248.2C334.185 243.8 333.785 239.1 333.285 234.1C332.885 229.4 332.385 224.4 332.185 219.1C332.185 217.5 333.085 216.1 334.585 215.5C335.285 207 335.985 196.6 335.385 189.8C334.385 178 332.485 169.7 331.085 164.8C331.085 164.6 331.085 164.4 330.985 164.2C329.385 149.6 326.685 137.4 322.985 128C322.985 127.8 322.885 127.6 322.785 127.4C321.885 122.8 318.585 117 313.885 111.7C309.085 106.3 300.885 101 293.085 98.1C292.985 98.1 292.885 98.1 292.785 98C291.185 97.3 289.685 96.6 287.985 95.9C273.585 89.9 260.885 88.5 259.585 88.4H186.885C185.585 88.5 170.785 90.1 154.585 97.7C154.385 97.7 154.185 97.9 153.985 97.9C145.785 100.7 137.285 106.1 132.185 111.9C127.185 117.6 123.785 123.9 123.285 128.3C123.285 128.6 123.185 128.9 123.085 129.2C118.485 141.4 116.285 155.7 115.285 165.6C115.285 165.8 115.285 166 115.185 166.2C114.085 169.9 112.185 177.9 111.185 190C110.185 203 113.385 229 113.385 229.3C113.385 229.6 113.385 229.8 113.385 230.1C113.285 231.5 113.085 233 112.985 234.4C112.485 239.4 112.085 244.1 111.985 248.5C111.985 250.2 110.785 251.6 109.085 252C102.785 253.3 94.0849 256.2 90.6849 259.8C87.5849 263.1 87.0849 268.3 87.1849 271.9L98.8849 266.8C98.8849 265.1 98.8849 261.4 101.185 258C102.385 256 104.285 254.4 106.785 253.1C107.885 252.5 109.185 252.6 110.285 253.3C111.385 254 111.985 255.1 111.985 256.4V268.4C111.985 268.7 112.085 269 112.085 269.3C112.085 269.8 111.685 318.3 111.685 334.6C111.685 350.9 111.285 351 110.885 356.5C110.685 358.7 110.485 360.9 110.285 363.9L110.085 366.7C109.985 368.6 109.885 370.3 109.785 371.8C109.485 378.3 109.185 385.4 109.185 393.2C108.985 419.5 108.985 424.5 110.285 448.6C110.285 448.6 110.285 448.7 110.285 448.8C110.285 449.7 110.285 450.6 110.485 451.6C110.485 452.1 110.485 452.6 110.585 453.1L110.785 456.5C111.285 465 111.685 471.2 112.085 476.1C112.385 480.5 112.685 484 112.985 487C113.185 489.8 113.485 492.4 113.585 495.2C113.985 501.5 113.385 506.5 112.585 511.8C112.085 515.4 111.585 519 111.485 523.2C110.985 535.5 112.385 548.4 115.485 560.5C116.785 565.8 118.285 569.3 119.785 572.6C120.885 575.2 122.085 577.8 122.985 581L123.385 582.3C123.685 583.5 123.985 584.6 124.285 585.5C124.285 585.8 124.385 586 124.485 586.3C124.785 587.4 124.985 588.5 125.285 589.6C125.585 590.7 125.285 590 125.285 590.2C125.285 590.3 125.285 590.4 125.385 590.5C125.385 590.7 125.485 590.9 125.485 591.1C125.485 591.1 125.485 591.1 125.485 591.2C125.685 591.5 125.785 591.9 125.785 592.3C125.985 592.6 126.085 592.9 126.185 593.1C126.385 593.5 126.485 593.9 126.585 594.2C126.685 594.4 126.785 594.6 126.885 594.8C126.985 595 126.885 594.9 126.885 595C126.885 595 126.885 595.1 126.985 595.2C127.185 595.4 127.285 595.7 127.485 595.9C127.485 596 127.585 596.2 127.685 596.3C127.685 596.3 127.685 596.4 127.785 596.5C127.785 596.5 127.885 596.7 127.985 596.8C127.985 596.8 127.985 596.9 128.085 597H128.185C128.385 597.3 128.585 597.6 128.785 597.8C128.785 597.8 128.985 598 129.085 598.1L129.285 598.3C129.485 598.5 129.685 598.7 129.885 599L130.085 599.2C130.385 599.5 130.585 599.7 130.685 600C130.685 600 130.785 600 130.885 600.2C131.085 600.4 131.285 600.6 131.485 600.9L132.285 601.7C132.485 601.8 132.685 602 132.885 602.2C132.885 602.2 132.885 602.3 133.085 602.4C133.285 602.5 133.485 602.7 133.585 602.8L134.285 603.5C134.885 604 135.385 604.5 135.885 605L136.185 605.3C136.685 605.7 137.185 606.2 137.785 606.7C137.985 606.8 138.185 606.9 138.385 607.1C138.585 607.3 138.785 607.4 138.985 607.6C138.985 607.6 139.185 607.7 139.185 607.8C139.385 607.9 139.485 608 139.585 608.1C139.685 608.1 139.785 608.2 139.885 608.3C140.085 608.5 140.285 608.6 140.585 608.8C140.685 608.8 140.885 609 140.985 609.1C141.185 609.1 141.285 609.3 141.385 609.4C141.685 609.6 141.985 609.9 142.385 610.1C142.885 610.5 143.385 610.8 143.985 611.3C144.285 611.5 144.585 611.7 144.885 611.9C144.985 611.9 145.085 612 145.185 612.1C145.485 612.1 145.785 612.3 145.985 612.5C146.385 612.8 146.885 613 147.385 613.3L148.185 612.9ZM136.285 613.5C136.285 613.5 136.385 613.5 136.485 613.6C136.485 613.6 136.385 613.6 136.285 613.5ZM140.285 607.6C140.285 607.6 140.385 607.6 140.485 607.7C140.485 607.7 140.385 607.7 140.285 607.6ZM323.685 599.2C323.685 599.3 323.485 599.4 323.385 599.5C323.385 599.5 323.585 599.3 323.685 599.2Z"
          fill="#231F20"
        />
        <path
          d="M323.485 545.1C323.485 593.5 283.085 632.8 233.185 632.8H204.585C154.685 632.8 114.285 593.5 114.285 545.1V169.6C114.285 121.2 154.685 85.2999 204.585 85.2999H233.185C283.085 85.2999 323.485 121.2 323.485 169.6V545.1Z"
          fill="#353635"
        />
        <path
          d="M332.685 157.9C332.685 157.9 337.485 168.4 339.185 189.4C340.285 202.9 336.885 229.8 336.885 229.8C336.885 229.8 335.385 212.9 334.085 194.2C332.685 175.5 332.685 157.8 332.685 157.8V157.9Z"
          fill="#010101"
        />
        <path
          d="M114.185 157.9C114.185 157.9 109.385 168.4 107.685 189.4C106.585 202.9 109.985 229.8 109.985 229.8C109.985 229.8 111.485 212.9 112.785 194.2C114.185 175.5 114.185 157.8 114.185 157.8V157.9Z"
          fill="#010101"
        />
        <path
          d="M110.685 204.2C109.585 186.1 110.485 128.8 131.185 109C137.985 102.5 145.685 97.7 153.185 94.2C170.785 86 186.885 85.1 186.885 85.1H259.885C259.885 85.1 276.585 86 294.485 94.6C301.685 98 308.985 102.7 315.585 109C336.285 128.8 337.185 186.1 336.085 204.2C334.985 222.3 338.185 236.7 338.185 249.4V268.7H108.585V249.4C108.585 236.7 111.785 222.3 110.685 204.2Z"
          fill="url(#paint0_linear_17_79)"
        />
        <path
          opacity="0.5"
          d="M293.885 95.6L294.385 94.6C276.585 86.1 259.985 84.6 259.885 84.6H186.885C186.685 84.6 170.585 86.1 153.185 94.2L153.385 94.7C170.685 86.7 186.785 85.7 186.885 85.7H259.785C259.885 85.7 276.285 87.2 293.885 95.6Z"
          fill="#343836"
        />
        <path
          d="M106.885 448.3C105.585 424.1 105.685 418.6 105.785 392.7C105.985 366.7 108.285 350.5 108.285 334.1C108.285 317.7 108.685 268.8 108.685 268.8H338.185C338.185 268.8 338.585 317.6 338.585 334.1C338.585 350.6 340.885 366.8 341.085 392.7C341.285 418.7 341.385 424.1 339.985 448.3C338.385 477.6 337.485 484.9 336.785 494.9C336.085 505 338.485 512 338.885 522.6C339.385 536.2 337.685 549.5 334.785 560.9C332.385 570.6 329.285 574.5 327.185 581.6C325.085 588.7 325.085 591.8 322.285 596.4C319.585 601.1 304.485 618.9 274.985 627.8C248.085 635.9 223.485 636.3 223.485 636.3H223.285C223.285 636.3 198.685 635.9 171.785 627.8C142.285 618.9 127.185 601.1 124.485 596.4C121.785 591.7 121.785 588.6 119.585 581.6C117.485 574.5 114.385 570.6 111.985 560.9C109.185 549.4 107.385 536.2 107.885 522.6C108.285 512 110.685 504.9 109.985 494.9C109.285 484.8 108.385 477.6 106.785 448.3H106.885Z"
          fill="url(#paint1_linear_17_79)"
        />
        <path
          d="M330.285 254.3C330.285 254.3 331.085 380.6 331.085 420C331.085 492.8 318.885 537.1 318.885 537.1C318.885 537.1 301.885 508.1 301.885 486.5C301.885 464.9 302.985 426.2 304.185 357.5C304.685 329.1 330.285 254.3 330.285 254.3Z"
          fill="url(#paint2_linear_17_79)"
        />
        <path
          opacity="0.7"
          d="M339.585 453C338.985 463.2 338.585 470.4 338.085 476C336.185 475.7 334.985 470.5 335.385 464.3C335.785 458.1 337.585 453.1 339.585 453Z"
          fill="#282B2A"
        />
        <path
          d="M116.485 254.3C116.485 254.3 115.685 380.6 115.685 420C115.685 492.8 127.885 537.1 127.885 537.1C127.885 537.1 144.885 508.1 144.885 486.5C144.885 464.9 143.785 426.2 142.585 357.5C142.085 329.1 116.485 254.3 116.485 254.3Z"
          fill="url(#paint3_linear_17_79)"
        />
        <path
          d="M144.485 555.9L155.185 502.8C155.385 501.7 156.385 501.3 157.285 501.9C161.385 504.7 180.185 514.3 223.285 514.3C266.385 514.3 285.285 504.8 289.385 501.9C290.385 501.3 291.285 501.6 291.485 502.8L302.185 555.9C302.385 557 301.885 558.6 300.885 559.3C296.585 562.4 284.285 570.6 265.385 575.5C244.385 581 223.385 581.3 223.385 581.3H223.185C223.185 581.3 202.185 581 181.185 575.5C162.285 570.6 149.885 562.4 145.685 559.3C144.785 558.6 144.185 557.1 144.385 555.9H144.485Z"
          fill="#040404"
        />
        <path
          d="M223.485 577.1C223.585 577.1 244.185 576.7 264.385 571.4C281.885 566.8 293.385 559.5 297.985 556.2L288.185 507.5C280.585 511.3 260.985 518.6 223.285 518.6C185.585 518.6 166.185 511.5 158.485 507.6L148.685 556.3C153.285 559.6 164.785 566.9 182.285 571.5C202.185 576.7 222.385 577.2 223.285 577.2H223.485V577.1Z"
          fill="url(#paint4_linear_17_79)"
        />
        <path
          d="M138.885 581.3C139.285 567.7 140.285 561.7 140.285 561.7C140.285 561.7 157.185 574 182.885 580.1C203.585 585 223.285 585.3 223.285 585.3L223.485 586V585.3C223.485 585.3 243.185 585 263.885 580.1C289.585 574 306.485 561.7 306.485 561.7C306.485 561.7 307.485 567.6 307.885 581.3C308.285 594.9 307.385 606.3 307.385 606.3C307.385 606.3 295.085 617.4 268.085 624.9C241.685 632.3 223.385 631.9 223.385 631.9V631.3L223.185 631.9C223.185 631.9 204.885 632.3 178.485 624.9C151.585 617.3 139.185 606.3 139.185 606.3C139.185 606.3 138.285 595 138.685 581.3H138.885Z"
          fill="url(#paint5_linear_17_79)"
        />
        <path
          opacity="0.7"
          d="M116.385 273.4C116.185 310.2 115.685 390.1 115.685 420C115.685 464.6 120.285 498.5 123.785 518.1C129.185 490.3 132.585 452 132.585 409.7C132.585 367.4 125.985 298.9 116.385 273.4Z"
          fill="url(#paint6_linear_17_79)"
        />
        <path
          style={{ mixBlendMode: "screen" }}
          d="M142.585 357.5C142.485 349.3 137.085 324.3 137.085 324.3C137.085 324.3 132.585 372 132.585 403.8C132.585 435.6 144.885 483.3 144.885 483.3C144.885 483.3 143.785 422.9 142.585 357.5Z"
          fill="url(#paint7_linear_17_79)"
        />
        <path
          d="M116.285 293.4C116.285 293.4 120.085 295.8 123.785 297C127.485 298.2 130.285 298.5 130.285 298.5L132.685 307.3C132.685 307.3 128.385 306.9 122.985 304.8C118.385 303 116.185 300.8 116.185 300.8V293.4H116.285Z"
          fill="#E2E2E2"
        />
        <path
          opacity="0.7"
          d="M107.085 453C107.685 463.2 108.085 470.4 108.585 476C110.485 475.7 111.685 470.5 111.285 464.3C110.885 458.1 109.085 453.1 107.085 453Z"
          fill="#282B2A"
        />
        <path
          opacity="0.7"
          d="M108.085 345.9C107.385 356.1 106.785 365.5 106.385 371.1C108.285 371.1 110.385 365.5 110.785 359.2C111.185 353 109.885 346.2 107.985 345.9H108.085Z"
          fill="#282B2A"
        />
        <path
          opacity="0.7"
          d="M338.685 345.9C339.385 356.1 339.985 365.5 340.385 371.1C338.485 371.1 336.285 365.5 335.985 359.2C335.585 353 336.885 346.2 338.785 345.9H338.685Z"
          fill="#282B2A"
        />
        <path
          d="M186.085 329.3C207.985 324.8 238.885 324.8 260.685 329.3C282.085 333.7 298.885 341 298.885 341L294.585 493.6C294.585 493.6 282.485 501.3 261.185 505.3C239.885 509.3 223.385 509.4 223.385 509.4H223.185C223.185 509.4 206.785 509.4 185.385 505.3C164.085 501.3 151.985 493.6 151.985 493.6L147.685 341C147.685 341 164.485 333.8 185.885 329.3H186.085Z"
          fill="url(#paint8_linear_17_79)"
        />
        <path
          d="M151.285 490.6C151.585 490.1 152.285 490 152.785 490.3C152.885 490.3 164.885 497.9 185.785 501.8C206.785 505.7 223.185 505.9 223.385 505.9H223.585C223.785 505.9 240.185 505.7 261.185 501.8C281.985 497.9 294.085 490.4 294.185 490.3C294.685 490 295.385 490.1 295.685 490.6C295.985 491.1 295.885 491.7 295.385 492.1C294.885 492.4 282.885 499.9 261.585 503.9C240.385 507.9 223.785 508 223.585 508H223.385C223.185 508 206.585 507.8 185.485 503.9C164.185 499.9 152.185 492.4 151.685 492.1C151.185 491.8 151.085 491.1 151.385 490.6H151.285Z"
          fill="#B7B7B8"
        />
        <path
          d="M220.585 489.4C220.585 491 221.885 492.3 223.485 492.3C225.085 492.3 226.385 491 226.385 489.4C226.385 487.8 225.085 486.5 223.485 486.5C221.885 486.5 220.585 487.8 220.585 489.4Z"
          fill="#323434"
        />
        <path
          d="M123.485 164.6C126.185 144.1 133.985 121.5 148.985 108.1C174.385 85.3 272.485 85.3 297.885 108.1C312.885 121.5 320.685 144.1 323.385 164.6C332.785 235.6 325.885 251.1 325.885 251.1L223.485 233.2L121.085 251.1C121.085 251.1 114.185 235.6 123.585 164.6H123.485Z"
          fill="url(#paint9_radial_17_79)"
        />
        <path
          style={{ mixBlendMode: "screen" }}
          opacity="0.5"
          d="M123.485 164.6C126.185 144.1 133.985 121.5 148.985 108.1C174.385 85.3 272.485 85.3 297.885 108.1C312.885 121.5 320.685 144.1 323.385 164.6C332.785 235.6 325.885 251.1 325.885 251.1H325.185C326.685 243.7 328.885 222.2 321.885 168.9C319.185 148.7 311.585 126.5 296.785 113.3C271.685 90.9 175.185 90.9 150.085 113.3C135.285 126.5 127.685 148.8 124.985 168.9C117.985 222.1 120.185 243.7 121.685 250.9H120.985C120.985 251 114.085 235.5 123.485 164.5V164.6Z"
          fill="url(#paint10_linear_17_79)"
        />
        <g style={{ mixBlendMode: "screen" }} opacity="0.6">
          <path
            d="M311.585 158.6C309.685 111.3 270.885 96.1 270.885 96.1C282.485 98.9 291.985 102.9 297.785 108.1C312.785 121.5 320.585 144.1 323.285 164.6C332.685 235.6 325.785 251.1 325.785 251.1L292.585 245.2C292.585 245.2 313.785 212.3 311.685 158.6H311.585Z"
            fill="#3A3B2A"
          />
        </g>
        <g style={{ mixBlendMode: "screen" }} opacity="0.6">
          <path
            d="M135.085 158.6C136.985 111.3 175.785 96.1 175.785 96.1C164.185 98.9 154.685 102.9 148.885 108.1C133.885 121.5 126.085 144.1 123.385 164.6C113.985 235.6 120.885 251.1 120.885 251.1L154.085 245.2C154.085 245.2 132.885 212.3 134.985 158.6H135.085Z"
            fill="#3A3B2A"
          />
        </g>
        <path
          d="M120.985 248.9C121.785 237.5 139.685 228.7 166.285 222.3C193.785 215.7 223.285 215.5 223.285 215.5C223.285 215.5 252.785 215.7 280.285 222.3C306.885 228.7 324.785 237.5 325.585 248.9C325.585 249.9 325.485 250.9 325.285 251.9L300.985 332C300.985 332 282.185 324.9 260.885 321.4C237.985 317.7 208.585 317.7 185.685 321.4C164.285 324.9 145.585 332 145.585 332L121.285 251.9C121.085 250.9 120.885 249.9 120.985 248.9Z"
          fill="#040404"
        />
        <path
          d="M321.285 250.8C321.385 250.2 321.485 249.6 321.485 249.2C320.885 241 305.585 232.7 279.385 226.4C252.585 220 223.585 219.7 223.285 219.7C222.985 219.7 193.985 220 167.285 226.4C141.085 232.7 125.785 240.9 125.185 249.2C125.185 249.6 125.185 250.2 125.385 250.8L148.385 326.5C155.185 324.2 169.385 319.7 185.085 317.2C196.585 315.3 209.785 314.4 223.385 314.4C236.985 314.4 250.185 315.4 261.685 317.2C277.385 319.7 291.585 324.2 298.385 326.5L321.385 250.8H321.285Z"
          fill="url(#paint11_linear_17_79)"
        />
        <path
          opacity="0.2"
          d="M125.985 246.5C129.385 239.2 144.085 232 167.285 226.5C193.985 220.1 223.085 219.8 223.285 219.8C223.485 219.8 252.585 220.1 279.385 226.5C299.785 231.4 313.585 237.5 318.985 243.8C313.985 244.8 308.585 245.7 303.085 246.6C302.285 251.7 287.085 256.5 268.285 257.3C252.985 258 239.885 256 234.785 252.5C228.285 252.7 221.585 252.8 214.785 252.8C181.885 252.8 151.285 250.5 125.885 246.5H125.985Z"
          fill="#724E45"
        />
        <path
          style={{ mixBlendMode: "screen" }}
          opacity="0.2"
          d="M223.385 314.3C214.585 314.3 205.885 314.7 197.685 315.5C203.685 268.3 242.985 231.6 291.185 229.5C310.085 235.2 320.985 242.2 321.485 249.1C321.485 249.5 321.485 250.1 321.285 250.7L298.285 326.4C291.485 324.1 277.285 319.6 261.585 317.1C250.085 315.2 236.885 314.3 223.285 314.3H223.385Z"
          fill="url(#paint12_linear_17_79)"
        />
        <path
          d="M321.685 135.3C322.985 135.3 323.985 135 324.785 134.3C325.885 133.4 326.585 132 326.685 130.2C327.185 124.9 323.285 116.6 316.785 109.3C308.285 99.7 292.585 92.5 284.285 92.5C275.985 92.5 281.185 92.8 280.385 93.5C279.885 93.9 279.685 94.3 279.685 95C279.385 99.9 294.985 107.5 301.985 114.7L303.985 116.8C313.185 126.3 316.585 135.4 321.685 135.4V135.3Z"
          fill="url(#paint13_linear_17_79)"
        />
        <path
          d="M321.685 134.2C322.685 134.2 323.485 134 324.085 133.4C324.985 132.7 325.485 131.6 325.585 130.1C325.985 125 322.285 117.1 315.985 110C307.685 100.6 292.385 93.5 284.285 93.5C276.185 93.5 281.385 94 280.985 94.2C280.785 94.4 280.685 94.5 280.585 94.9C280.385 97.3 286.285 101.4 291.485 105C295.585 107.9 299.785 110.8 302.585 113.8L304.585 115.9C308.185 119.7 310.985 123.4 313.185 126.4C316.485 130.9 318.885 134.1 321.485 134.1H321.685V134.2Z"
          fill="url(#paint14_linear_17_79)"
        />
        <path
          style={{ mixBlendMode: "screen" }}
          d="M314.985 124.1C315.785 124.1 316.485 123.8 316.985 123.3C317.685 122.7 318.085 121.7 318.185 120.5C318.285 116.9 315.485 111.6 310.985 106.9C305.085 100.8 294.385 96.4 288.885 96.7C287.685 96.7 286.785 97 286.285 97.5C285.985 97.8 285.885 98.1 285.885 98.5C285.885 101.8 296.485 106.3 301.285 110.9L302.685 112.2C309.085 118.3 311.585 124.2 314.985 124V124.1Z"
          fill="url(#paint15_linear_17_79)"
        />
        <path
          d="M124.785 135.3C123.485 135.3 122.485 135 121.685 134.3C120.585 133.4 119.885 132 119.785 130.2C119.285 124.9 123.185 116.6 129.685 109.3C138.185 99.7 153.885 92.5 162.185 92.5C170.485 92.5 165.285 92.8 166.085 93.5C166.585 93.9 166.785 94.3 166.785 95C167.085 99.9 151.485 107.5 144.485 114.7L142.485 116.8C133.285 126.3 129.885 135.4 124.785 135.4V135.3Z"
          fill="url(#paint16_linear_17_79)"
        />
        <path
          d="M124.785 134.2C123.785 134.2 122.985 134 122.385 133.4C121.485 132.7 120.985 131.6 120.885 130.1C120.485 125 124.285 117.1 130.485 110C138.785 100.6 154.085 93.5 162.185 93.5C170.285 93.5 165.085 94 165.485 94.2C165.685 94.4 165.785 94.5 165.885 94.9C166.085 97.3 160.185 101.4 154.985 105C150.885 107.9 146.685 110.8 143.885 113.8L141.885 115.9C138.285 119.7 135.485 123.4 133.285 126.4C129.985 130.9 127.585 134.1 124.985 134.1H124.785V134.2Z"
          fill="url(#paint17_linear_17_79)"
        />
        <path
          style={{ mixBlendMode: "screen" }}
          d="M131.485 124.1C130.685 124.1 129.985 123.8 129.485 123.3C128.785 122.7 128.385 121.7 128.285 120.5C128.185 116.9 130.985 111.6 135.485 106.9C141.385 100.8 152.085 96.4 157.585 96.7C158.785 96.7 159.685 97 160.185 97.5C160.485 97.8 160.585 98.1 160.685 98.5C160.685 101.8 150.085 106.3 145.285 110.9L143.885 112.2C137.485 118.3 134.985 124.2 131.585 124H131.485V124.1Z"
          fill="url(#paint18_linear_17_79)"
        />
        <path
          d="M167.285 226.4C179.285 223.5 191.785 221.9 201.985 221C205.085 257 219.985 289.7 242.785 315C236.485 314.5 229.985 314.3 223.385 314.3C209.785 314.3 196.585 315.3 185.085 317.1C169.385 319.6 155.185 324.1 148.385 326.4L125.385 250.7C125.285 250.1 125.185 249.5 125.185 249.1C125.785 240.9 141.085 232.6 167.285 226.3V226.4Z"
          fill="url(#paint19_linear_17_79)"
        />
        <path
          opacity="0.7"
          d="M330.385 273.4C330.585 310.2 331.085 390.1 331.085 420C331.085 464.6 326.485 498.5 322.985 518.1C317.585 490.3 314.185 452 314.185 409.7C314.185 367.4 320.785 298.9 330.385 273.4Z"
          fill="url(#paint20_linear_17_79)"
        />
        <path
          style={{ mixBlendMode: "screen" }}
          d="M304.185 357.5C304.285 349.3 306.585 337.3 309.685 324.3C317.085 344 320.885 372.7 319.385 404.5C317.885 436.2 311.185 464.4 301.985 483.3C301.985 461 303.085 422.9 304.285 357.5H304.185Z"
          fill="url(#paint21_linear_17_79)"
        />
        <path
          d="M330.485 293.4C330.485 293.4 326.685 295.8 322.985 297C319.285 298.2 316.485 298.5 316.485 298.5L314.085 307.3C314.085 307.3 318.385 306.9 323.785 304.8C328.385 303 330.585 300.8 330.585 300.8V293.4H330.485Z"
          fill="#E2E2E2"
        />
        <path
          d="M158.585 507.6C165.385 511 181.085 516.9 210.385 518.3C218.985 540.9 234.285 560.2 253.785 573.8C237.585 576.8 223.585 577.1 223.485 577.1H223.385C222.485 577.1 202.285 576.6 182.385 571.4C164.885 566.8 153.385 559.5 148.785 556.2L158.585 507.5V507.6Z"
          fill="url(#paint22_linear_17_79)"
        />
        <path
          d="M300.685 605.4C300.685 605.4 305.385 604 312.285 598.4C319.385 592.6 324.185 585.2 324.185 585.1L326.085 585.9C324.985 590.2 324.485 592.8 322.385 596.5C320.485 599.7 312.985 608.9 299.185 617.3V605.9L300.785 605.5L300.685 605.4Z"
          fill="url(#paint23_linear_17_79)"
        />
        <path
          d="M325.885 586.3C324.885 590.4 324.385 593 322.285 596.5C320.485 599.5 313.685 608 301.185 616V607.5C301.185 607.5 306.085 606.2 313.585 600.1C320.985 594 325.885 586.3 325.885 586.3Z"
          fill="url(#paint24_linear_17_79)"
        />
        <path
          d="M134.585 598.4C141.485 604.1 146.085 605.4 146.185 605.4L147.785 605.8V617.3C133.985 608.9 126.385 599.7 124.585 596.5C122.485 592.9 121.985 590.2 120.885 585.9L122.785 585.1C122.785 585.1 127.585 592.6 134.685 598.4H134.585Z"
          fill="url(#paint25_linear_17_79)"
        />
        <path
          d="M120.885 586.3C121.885 590.4 122.385 593 124.485 596.5C126.285 599.5 133.085 608 145.585 616V607.5C145.585 607.5 140.685 606.2 133.185 600.1C125.785 594 120.885 586.3 120.885 586.3Z"
          fill="url(#paint26_linear_17_79)"
        />
        <path
          style={{ mixBlendMode: "screen" }}
          d="M322.685 546C320.385 565.5 321.385 581.7 324.885 582.1C328.385 582.5 333.085 567 335.385 547.5C337.685 528 336.685 511.8 333.185 511.4C329.685 511 324.985 526.5 322.685 546Z"
          fill="url(#paint27_radial_17_79)"
        />
        <path
          style={{ mixBlendMode: "screen" }}
          d="M125.285 546C127.585 565.5 126.585 581.7 123.085 582.1C119.585 582.5 114.885 567 112.585 547.5C110.285 528 111.285 511.8 114.785 511.4C118.285 511 122.985 526.5 125.285 546Z"
          fill="url(#paint28_radial_17_79)"
        />
        <path
          d="M331.085 420.1C331.085 386.5 330.485 289.5 330.285 261.8C331.785 257.1 332.785 254.3 332.785 254.3C332.785 254.3 333.585 380.6 333.585 420C333.585 492.8 321.385 537.1 321.385 537.1C321.385 537.1 320.685 535.9 319.685 534C322.385 522.7 331.085 481.5 331.085 420V420.1Z"
          fill="#F7F8F8"
        />
        <path
          d="M115.685 420.1C115.685 386.5 116.285 289.5 116.385 261.8C114.885 257.1 113.885 254.3 113.885 254.3C113.885 254.3 113.085 380.6 113.085 420C113.085 492.8 125.285 537.1 125.285 537.1C125.285 537.1 125.985 535.9 126.985 534C124.285 522.7 115.585 481.5 115.585 420L115.685 420.1Z"
          fill="#F7F8F8"
        />
        <path
          d="M144.185 409.5L113.185 407.3V418L144.485 420.8L144.185 409.5Z"
          fill="#E2E2E2"
        />
        <path
          d="M302.585 409.5L333.585 407.3V418L302.385 420.8L302.585 409.5Z"
          fill="#E2E2E2"
        />
        <path
          d="M336.485 247.7C336.485 247.7 352.485 250.6 358.485 256.8C363.585 262.1 363.185 270.7 362.685 274.6C362.585 275.8 361.485 276.3 360.385 275.8L345.685 269.4C344.585 268.9 343.985 267.6 343.985 266.5C343.985 264.7 343.885 262 342.285 259.5C339.785 255.4 334.685 254.9 334.685 254.9C333.185 254.6 332.385 252.7 332.785 250.7C333.185 248.7 334.785 247.3 336.285 247.7H336.485Z"
          fill="url(#paint29_radial_17_79)"
        />
        <path
          d="M344.185 267.2L362.785 274.8C362.585 275.9 361.585 276.3 360.585 275.9L345.885 269.5C344.985 269.1 344.385 268.2 344.285 267.2H344.185Z"
          fill="#040404"
        />
        <path
          d="M110.285 247.7C110.285 247.7 94.285 250.6 88.285 256.8C83.185 262.1 83.585 270.7 84.085 274.6C84.185 275.8 85.285 276.3 86.385 275.8L101.085 269.4C102.185 268.9 102.785 267.6 102.785 266.5C102.785 264.7 102.885 262 104.485 259.5C107.085 255.4 112.085 254.9 112.085 254.9C113.585 254.6 114.385 252.7 113.985 250.7C113.485 248.7 111.985 247.3 110.485 247.7H110.285Z"
          fill="url(#paint30_radial_17_79)"
        />
        <path
          d="M102.685 267.2L84.085 274.8C84.285 275.9 85.285 276.3 86.285 275.9L100.985 269.5C101.885 269.1 102.485 268.2 102.585 267.2H102.685Z"
          fill="#040404"
        />
        <defs>
          <linearGradient
            id="paint0_linear_17_79"
            x1="338.185"
            y1="176.9"
            x2="108.585"
            y2="176.9"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D9D9D9" />
            <stop offset="0.2" stopColor="#F2F2F2" />
            <stop offset="0.9" stopColor="#F0F0F0" />
            <stop offset="1" stopColor="#C4C4C4" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_17_79"
            x1="105.685"
            y1="452.5"
            x2="341.185"
            y2="452.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D9D9D9" />
            <stop offset="0.2" stopColor="#F2F2F2" />
            <stop offset="0.9" stopColor="#F0F0F0" />
            <stop offset="1" stopColor="#C4C4C4" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_17_79"
            x1="300.685"
            y1="395.7"
            x2="329.885"
            y2="395.7"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#373636" />
            <stop offset="0.4" stopColor="#222222" />
            <stop offset="1" stopColor="#010101" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_17_79"
            x1="115.685"
            y1="395.7"
            x2="144.885"
            y2="395.7"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#010101" />
            <stop offset="0.6" stopColor="#222222" />
            <stop offset="1" stopColor="#373636" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_17_79"
            x1="297.985"
            y1="542.3"
            x2="148.685"
            y2="542.3"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#373636" />
            <stop offset="0.4" stopColor="#222222" />
            <stop offset="1" stopColor="#010101" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_17_79"
            x1="223.285"
            y1="631.9"
            x2="223.285"
            y2="561.7"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.7" stopColor="#E6E6E6" />
            <stop offset="0.8" stopColor="#E3E3E3" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_17_79"
            x1="104.585"
            y1="395.8"
            x2="121.485"
            y2="395.8"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#878787" />
            <stop offset="0.2" stopColor="#727272" />
            <stop offset="0.6" stopColor="#3D3D3D" />
            <stop offset="1" stopColor="#010101" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_17_79"
            x1="118.685"
            y1="403.8"
            x2="140.485"
            y2="403.8"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#C2C1C1" />
            <stop offset="0.4" stopColor="#8D8D8D" />
            <stop offset="0.8" stopColor="#393939" />
            <stop offset="1" stopColor="#010101" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_17_79"
            x1="223.285"
            y1="325.9"
            x2="223.285"
            y2="509.4"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="0.7" stopColor="#E6E6E6" />
            <stop offset="0.8" stopColor="#E3E3E3" />
          </linearGradient>
          <radialGradient
            id="paint9_radial_17_79"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(223.485 171.1) rotate(180) scale(136.3 136.3)"
          >
            <stop offset="0.2" stopColor="#F7F7F7" />
            <stop offset="0.4" stopColor="#F3F3F3" />
            <stop offset="0.5" stopColor="#F2F2F2" />
            <stop offset="0.8" stopColor="#D9D9D9" />
            <stop offset="0.9" stopColor="#D3D3D3" />
            <stop offset="1" stopColor="#C4C4C4" />
          </radialGradient>
          <linearGradient
            id="paint10_linear_17_79"
            x1="328.285"
            y1="171.1"
            x2="118.585"
            y2="171.1"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD72C" />
            <stop offset="0.5" stopColor="#FFE67E" />
            <stop offset="0.9" stopColor="#FFD835" />
            <stop offset="1" stopColor="#EBA823" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_17_79"
            x1="321.485"
            y1="273.1"
            x2="125.185"
            y2="273.1"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#373636" />
            <stop offset="0.4" stopColor="#222222" />
            <stop offset="1" stopColor="#010101" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_17_79"
            x1="308.585"
            y1="204.5"
            x2="279.485"
            y2="257"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F9F9F9" />
            <stop offset="0.4" stopColor="#878787" />
            <stop offset="0.7" stopColor="#404040" />
            <stop offset="0.8" stopColor="#242424" />
            <stop offset="1" />
          </linearGradient>
          <linearGradient
            id="paint13_linear_17_79"
            x1="319.585"
            y1="122.7"
            x2="281.985"
            y2="94.3"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2" stopColor="#F7F7F7" />
            <stop offset="0.4" stopColor="#F3F3F3" />
            <stop offset="0.5" stopColor="#F2F2F2" />
            <stop offset="0.8" stopColor="#D9D9D9" />
            <stop offset="0.9" stopColor="#D3D3D3" />
            <stop offset="1" stopColor="#C4C4C4" />
          </linearGradient>
          <linearGradient
            id="paint14_linear_17_79"
            x1="318.585"
            y1="121.8"
            x2="282.285"
            y2="95.2"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2" stopColor="#F7F7F7" />
            <stop offset="0.4" stopColor="#F3F3F3" />
            <stop offset="0.5" stopColor="#F2F2F2" />
            <stop offset="0.8" stopColor="#D9D9D9" />
            <stop offset="0.9" stopColor="#D3D3D3" />
            <stop offset="1" stopColor="#C4C4C4" />
          </linearGradient>
          <linearGradient
            id="paint15_linear_17_79"
            x1="318.185"
            y1="110.4"
            x2="285.885"
            y2="110.4"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#323232" />
            <stop offset="0.2" stopColor="#626262" />
            <stop offset="0.3" stopColor="#8C8C8C" />
            <stop offset="0.4" stopColor="#AFAFAF" />
            <stop offset="0.5" stopColor="#CCCCCC" />
            <stop offset="0.6" stopColor="#E2E2E2" />
            <stop offset="0.7" stopColor="#F2F2F2" />
            <stop offset="0.8" stopColor="#FCFCFC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint16_linear_17_79"
            x1="130.785"
            y1="119.7"
            x2="169.085"
            y2="92.2"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2" stopColor="#F7F7F7" />
            <stop offset="0.4" stopColor="#F3F3F3" />
            <stop offset="0.5" stopColor="#F2F2F2" />
            <stop offset="0.8" stopColor="#D9D9D9" />
            <stop offset="0.9" stopColor="#D3D3D3" />
            <stop offset="1" stopColor="#C4C4C4" />
          </linearGradient>
          <linearGradient
            id="paint17_linear_17_79"
            x1="126.685"
            y1="122.1"
            x2="164.585"
            y2="97.8"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2" stopColor="#F7F7F7" />
            <stop offset="0.4" stopColor="#F3F3F3" />
            <stop offset="0.5" stopColor="#F2F2F2" />
            <stop offset="0.8" stopColor="#D9D9D9" />
            <stop offset="0.9" stopColor="#D3D3D3" />
            <stop offset="1" stopColor="#C4C4C4" />
          </linearGradient>
          <linearGradient
            id="paint18_linear_17_79"
            x1="128.285"
            y1="110.4"
            x2="160.585"
            y2="110.4"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#323232" />
            <stop offset="0.2" stopColor="#626262" />
            <stop offset="0.3" stopColor="#8C8C8C" />
            <stop offset="0.4" stopColor="#AFAFAF" />
            <stop offset="0.5" stopColor="#CCCCCC" />
            <stop offset="0.6" stopColor="#E2E2E2" />
            <stop offset="0.7" stopColor="#F2F2F2" />
            <stop offset="0.8" stopColor="#FCFCFC" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint19_linear_17_79"
            x1="287.585"
            y1="253.6"
            x2="168.885"
            y2="278.1"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#878787" />
            <stop offset="0.2" stopColor="#727272" />
            <stop offset="0.6" stopColor="#3D3D3D" />
            <stop offset="1" stopColor="#010101" />
          </linearGradient>
          <linearGradient
            id="paint20_linear_17_79"
            x1="342.185"
            y1="395.8"
            x2="325.285"
            y2="395.8"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#878787" />
            <stop offset="0.2" stopColor="#727272" />
            <stop offset="0.6" stopColor="#3D3D3D" />
            <stop offset="1" stopColor="#010101" />
          </linearGradient>
          <linearGradient
            id="paint21_linear_17_79"
            x1="339.885"
            y1="403.8"
            x2="308.285"
            y2="403.8"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#C2C1C1" />
            <stop offset="0.4" stopColor="#8D8D8D" />
            <stop offset="0.8" stopColor="#393939" />
            <stop offset="1" stopColor="#010101" />
          </linearGradient>
          <linearGradient
            id="paint22_linear_17_79"
            x1="318.085"
            y1="542.3"
            x2="156.085"
            y2="542.3"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#878787" />
            <stop offset="0.2" stopColor="#727272" />
            <stop offset="0.6" stopColor="#3D3D3D" />
            <stop offset="1" stopColor="#010101" />
          </linearGradient>
          <linearGradient
            id="paint23_linear_17_79"
            x1="325.985"
            y1="601.2"
            x2="299.085"
            y2="601.2"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D71F2B" />
            <stop offset="0.4" stopColor="#DF2E3F" />
            <stop offset="1" stopColor="#EF4A64" />
          </linearGradient>
          <linearGradient
            id="paint24_linear_17_79"
            x1="325.885"
            y1="601.2"
            x2="301.185"
            y2="601.2"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D71F2B" />
            <stop offset="0.2" stopColor="#DC323F" />
            <stop offset="0.7" stopColor="#E96473" />
            <stop offset="1" stopColor="#F48E9F" />
          </linearGradient>
          <linearGradient
            id="paint25_linear_17_79"
            x1="147.685"
            y1="601.2"
            x2="120.785"
            y2="601.2"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EF4A64" />
            <stop offset="0.6" stopColor="#DF2E3F" />
            <stop offset="1" stopColor="#D71F2B" />
          </linearGradient>
          <linearGradient
            id="paint26_linear_17_79"
            x1="120.885"
            y1="601.2"
            x2="145.585"
            y2="601.2"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D71F2B" />
            <stop offset="0.2" stopColor="#DC323F" />
            <stop offset="0.7" stopColor="#E96473" />
            <stop offset="1" stopColor="#F48E9F" />
          </linearGradient>
          <radialGradient
            id="paint27_radial_17_79"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(328.664 545.402) rotate(-173.3) scale(25.6 25.6)"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#010101" />
          </radialGradient>
          <radialGradient
            id="paint28_radial_17_79"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(119.129 547.502) rotate(-6.70001) scale(25.6 25.6)"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#010101" />
          </radialGradient>
          <radialGradient
            id="paint29_radial_17_79"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(2066.79 214.6) scale(14.6 14.6)"
          >
            <stop offset="0.2" stopColor="#F7F7F7" />
            <stop offset="0.4" stopColor="#F3F3F3" />
            <stop offset="0.5" stopColor="#F2F2F2" />
            <stop offset="0.8" stopColor="#D9D9D9" />
            <stop offset="0.9" stopColor="#D3D3D3" />
            <stop offset="1" stopColor="#C4C4C4" />
          </radialGradient>
          <radialGradient
            id="paint30_radial_17_79"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(2315.98 214.6) scale(14.6 14.6)"
          >
            <stop offset="0.2" stopColor="#F7F7F7" />
            <stop offset="0.4" stopColor="#F3F3F3" />
            <stop offset="0.5" stopColor="#F2F2F2" />
            <stop offset="0.8" stopColor="#D9D9D9" />
            <stop offset="0.9" stopColor="#D3D3D3" />
            <stop offset="1" stopColor="#C4C4C4" />
          </radialGradient>
        </defs>
      </svg>
    </Box>
  );
}
